(function () {
  var storageKey = 'chicchokStyleMode';
  var validModes = ['auto', 'light', 'dark'];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var currentMode = readMode();
  var revealObserver = null;
  var flashmailObserver = null;
  var flashmailFrameObserver = null;
  var flashmailFrameDocument = null;
  var flashmailPollTimer = null;
  var flashmailPollAttempts = 0;
  var flashmailSyncFrame = null;
  var flashmailLoadBound = new WeakSet();
  var flashmailEventsDocument = null;
  var flashmailSelector = '#popup-shadow-root, #flashmail-popup, .popup-block.node-type-sticky_tab';
  var flashmailBlockSelector = '#flashmail-popup, .popup-block';
  var cartmaxObserver = null;
  var cartmaxSyncFrame = null;
  var cartmaxShadowObservers = new WeakMap();
  var lightEnhancementsReady = false;
  var collectionOverlayFixReady = false;
  var zalifyPopupNudgeReady = false;
  var zalifyPopupStartAttempted = false;
  var styleTransitionTimer = null;

  function readMode() {
    var mode = 'auto';

    try {
      mode = window.localStorage.getItem(storageKey) || 'auto';
    } catch (error) {
      mode = 'auto';
    }

    return validModes.indexOf(mode) === -1 ? 'auto' : mode;
  }

  function storeMode(mode) {
    currentMode = validModes.indexOf(mode) === -1 ? 'auto' : mode;

    try {
      window.localStorage.setItem(storageKey, currentMode);
    } catch (error) {
      return;
    }
  }

  function resolveStyle(mode) {
    if (mode === 'light' || mode === 'dark') {
      return mode;
    }

    var hour = new Date().getHours();
    return hour >= 7 && hour <= 18 ? 'light' : 'dark';
  }

  function isLightStyle() {
    return document.documentElement.getAttribute('data-chicchok-style') === 'light';
  }

  function getCartmaxStyleText(hostTagName) {
    if (hostTagName === 'CARTMAX-TITLE-NAV') {
      return [
        ':host{--cartmax-title-nav-hover-bg:#f8f3ea!important;color:#7a1018!important;}',
        '.cartmax-title-svg{--cartmax-title-nav-hover-bg:#f8f3ea!important;}',
        '.cartmax-title-svg-bt{color:#7a1018!important;}',
        '.cartmax-title-svg-bt svg path{fill:#7a1018!important;}'
      ].join('');
    }

    if (hostTagName !== 'CHECKBOK-CARD') {
      return '';
    }

    return [
      ':host{color:#231f1e!important;}',
      '.cartmax-card-bundle{color:#231f1e!important;}',
      '.cartmax-title{color:#7a1018!important;}',
      '.cartmax-card{background:#fff!important;border-color:#e3d8ca!important;color:#231f1e!important;box-shadow:0 14px 34px rgba(35,32,30,.08)!important;}',
      '.cartmax-list-check{border-color:#e3d8ca!important;}',
      '.cartmax-card-content-left-content-text-can,.cartmax-card-content-left-content-text-can span{color:#231f1e!important;}',
      '.cartmax-card-content-left-content-text-price,.cartmax-card-content-left-content-text-price-amount{color:#7a1018!important;}',
      '.cartmax-card-content-left-content-text-price-line{color:#8c8178!important;}',
      '.cartmax-card-footer,.footer-bottom,.footer-dis,.footer-total{color:#231f1e!important;}',
      'cartmax-title-nav{--cartmax-title-nav-hover-bg:#f8f3ea!important;}',
      'cartmax-select-pro{--text-color:#231f1e!important;--border-color:#c7b8a4!important;--icon-color:#7a1018!important;--background-color:#fcfaf5!important;--background-color-active:#f8f3ea!important;--popups-background-color:#fff!important;}',
      'cartmax-checkbox{--checkbox-color:#fff!important;--checkbox-bg-color:#7a1018!important;--un-checkout-bg-color:#fff!important;}',
      'cartmax-tag{--tag-background-color:#7a1018!important;--tag-text-color:#fff!important;}',
      'cartmax-button{--background-color:#7a1018!important;--hover-background-color:#5f0b11!important;--button-color:#fff!important;}'
    ].join('');
  }

  function syncCartmaxShadowRoot(host, resolvedStyle) {
    var root = host && host.shadowRoot;

    if (!root) {
      return;
    }

    // Keep Lit's marker nodes intact so future offer updates can still render.
    if (host.tagName === 'CHECKBOK-CARD') {
      Array.from(root.querySelectorAll('.cartmax-title')).forEach(function (title) {
        Array.from(title.childNodes).forEach(function (node) {
          if (node.nodeType === 3 && /^\s*Buy it together Get 0 Off\s*$/i.test(node.nodeValue || '')) {
            node.nodeValue = 'Complete the look';
          }
        });
      });
    }

    var styleId = 'chicchok-cartmax-dual-style';
    var style = root.getElementById ? root.getElementById(styleId) : root.querySelector('#' + styleId);
    var styleText = getCartmaxStyleText(host.tagName);

    if (resolvedStyle !== 'light' || !styleText) {
      if (style) {
        style.remove();
      }
    } else if (!style || style.textContent !== styleText) {
      if (!style) {
        style = document.createElement('style');
        style.id = styleId;
        root.appendChild(style);
      }

      style.textContent = styleText;
    }

    Array.from(root.querySelectorAll('*')).forEach(function (nestedHost) {
      if (nestedHost.shadowRoot) {
        syncCartmaxShadowRoot(nestedHost, resolvedStyle);
      }
    });

    if (!cartmaxShadowObservers.has(root) && 'MutationObserver' in window) {
      var shadowObserver = new MutationObserver(function () {
        scheduleCartmaxSync();
      });

      shadowObserver.observe(root, {
        childList: true,
        subtree: true,
        characterData: true
      });
      cartmaxShadowObservers.set(root, shadowObserver);
    }
  }

  function syncCartmaxBundleStyles(resolvedStyle) {
    Array.from(document.querySelectorAll('checkbok-card')).forEach(function (host) {
      syncCartmaxShadowRoot(host, resolvedStyle);
    });
  }

  function syncAfterpayPlacementStyles(resolvedStyle) {
    var isDark = resolvedStyle === 'dark';

    Array.from(document.querySelectorAll('afterpay-placement')).forEach(function (placement) {
      var hasExpectedAttributes = isDark ? (
        placement.getAttribute('data-logo-type') === 'lockup' &&
        placement.getAttribute('data-lockup-theme') === 'mint'
      ) : (
        !placement.hasAttribute('data-logo-type') &&
        !placement.hasAttribute('data-lockup-theme')
      );

      function applyAttributes(target) {
        if (isDark) {
          target.setAttribute('data-logo-type', 'lockup');
          target.setAttribute('data-lockup-theme', 'mint');
        } else {
          target.removeAttribute('data-logo-type');
          target.removeAttribute('data-lockup-theme');
        }
      }

      if (!placement.shadowRoot) {
        applyAttributes(placement);
        return;
      }

      if (hasExpectedAttributes) {
        return;
      }

      var replacement = placement.cloneNode(true);
      applyAttributes(replacement);
      placement.replaceWith(replacement);
    });
  }

  function scheduleCartmaxSync() {
    if (cartmaxSyncFrame !== null) {
      return;
    }

    cartmaxSyncFrame = window.requestAnimationFrame(function () {
      cartmaxSyncFrame = null;
      syncCartmaxBundleStyles(document.documentElement.getAttribute('data-chicchok-style'));
    });
  }

  function bindCartmaxObserver() {
    scheduleCartmaxSync();

    if (cartmaxObserver || !('MutationObserver' in window)) {
      return;
    }

    cartmaxObserver = new MutationObserver(function (mutations) {
      var hasCartmaxChange = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('checkbok-card') || node.querySelector('checkbok-card'));
        });
      });

      if (hasCartmaxChange) {
        scheduleCartmaxSync();
      }
    });

    cartmaxObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    [300, 900, 1800, 3500, 6000].forEach(function (delay) {
      window.setTimeout(scheduleCartmaxSync, delay);
    });
  }

  function syncHomeHeroSlideLimit(resolvedStyle) {
    var slideshow = document.querySelector('body.template-index #main > .shopify-section--slideshow:first-child slide-show');

    if (!slideshow) {
      return;
    }

    if (!slideshow.chicchokAllItems) {
      slideshow.chicchokAllItems = Array.from(slideshow.querySelectorAll('slide-show-item'));
    }

    if (slideshow.pageDots && !slideshow.pageDots.chicchokAllButtons) {
      slideshow.pageDots.chicchokAllButtons = Array.from(slideshow.pageDots.querySelectorAll('button'));
    }

    var isLight = resolvedStyle === 'light';
    var items = isLight ? slideshow.chicchokAllItems.filter(function (item) {
      return item.getAttribute('data-chicchok-light-excluded') !== 'true';
    }) : slideshow.chicchokAllItems;
    var buttons = slideshow.pageDots ? (isLight ? slideshow.pageDots.chicchokAllButtons.filter(function (button) {
      return button.getAttribute('data-chicchok-light-excluded') !== 'true';
    }) : slideshow.pageDots.chicchokAllButtons) : [];

    if (items.length) {
      slideshow.items = items;
    }

    if (slideshow.pageDots && buttons.length) {
      slideshow.pageDots.buttons = buttons;
    }

    if (!isLight) {
      return;
    }

    var selectedExcludedItem = slideshow.chicchokAllItems.find(function (item) {
      return !item.hasAttribute('hidden') && item.getAttribute('data-chicchok-light-excluded') === 'true';
    });

    if (selectedExcludedItem) {
      selectedExcludedItem.setAttribute('hidden', '');

      if (typeof slideshow.select === 'function') {
        slideshow.select(0, false, false);
      }
    }
  }

  function commitStyle(safeMode, resolvedStyle) {
    document.documentElement.setAttribute('data-chicchok-style-mode', safeMode);
    document.documentElement.setAttribute('data-chicchok-style', resolvedStyle);

    syncHomeHeroSlideLimit(resolvedStyle);
    syncSwitchers(safeMode);
    syncCartmaxBundleStyles(resolvedStyle);
    syncAfterpayPlacementStyles(resolvedStyle);

    if (resolvedStyle === 'light') {
      initLightEnhancements();
    }

    markFlashmailStickyHost();
  }

  function applyStyle(mode, options) {
    var safeMode = validModes.indexOf(mode) === -1 ? 'auto' : mode;
    var resolvedStyle = resolveStyle(safeMode);
    var currentStyle = options && options.fromStyle ? options.fromStyle : document.documentElement.getAttribute('data-chicchok-style');
    var shouldAnimate = options && options.animate && currentStyle && currentStyle !== resolvedStyle && !reduceMotion && document.body;

    if (shouldAnimate) {
      runStyleTransition(safeMode, resolvedStyle, options.originElement);
      return;
    }

    commitStyle(safeMode, resolvedStyle);
  }

  function getStyleTransitionOrigin(originElement) {
    if (originElement && originElement.getBoundingClientRect) {
      var rect = originElement.getBoundingClientRect();

      if (rect.width || rect.height) {
        return {
          x: rect.left + rect.width / 2,
          y: rect.top + rect.height / 2
        };
      }
    }

    return {
      x: window.innerWidth - 72,
      y: 84
    };
  }

  function getStyleTransitionRadius(origin) {
    var corners = [
      [0, 0],
      [window.innerWidth, 0],
      [0, window.innerHeight],
      [window.innerWidth, window.innerHeight]
    ];
    var radius = 0;

    corners.forEach(function (corner) {
      radius = Math.max(radius, Math.hypot(corner[0] - origin.x, corner[1] - origin.y));
    });

    return Math.ceil(radius + 80);
  }

  function setStyleSwitchersDisabled(disabled) {
    document.querySelectorAll('[data-chicchok-style-trigger], [data-chicchok-style-option]').forEach(function (button) {
      if ('disabled' in button) {
        button.disabled = disabled;
      }
    });
  }

  function clearStyleTransition() {
    if (styleTransitionTimer) {
      window.clearTimeout(styleTransitionTimer);
      styleTransitionTimer = null;
    }

    document.documentElement.classList.remove('chicchok-style-transitioning', 'chicchok-style-transitioning--light', 'chicchok-style-transitioning--dark');
    document.querySelectorAll('[data-chicchok-style-transition-item]').forEach(function (item) {
      item.removeAttribute('data-chicchok-style-transition-item');
      item.style.removeProperty('--chicchok-style-transition-delay');
    });
    document.querySelectorAll('.chicchok-style-transition-veil').forEach(function (veil) {
      veil.remove();
    });
    setStyleSwitchersDisabled(false);
  }

  function isTransitionExcluded(element) {
    return !!(element.closest && element.closest([
      '.chicchok-style-switcher',
      '.chicchok-style-transition-veil',
      '#flashmail-popup',
      '#popup-shadow-root',
      '#shopify-pc__banner',
      '.cookie-bar',
      '#PBarNextFrameWrapper',
      '#ShopifyChat',
      '#smile-ui-lite-launcher-frame-container',
      'salesmartly-chat-widget'
    ].join(',')));
  }

  function collectStyleTransitionItems(origin) {
    var selectors = [
      '.shopify-section--announcement-bar',
      '.shopify-section--header',
      '.header__wrapper',
      '.header__bottom-navigation',
      '#mobile-facet-toolbar',
      '#main > *',
      '#main > .shopify-section',
      '#main .product-facet__meta-bar',
      '#main .product-facet__aside',
      '#main .article__prev-next',
      '#main .cart',
      '#main .product',
      '#main .page-header',
      '.shopify-section--footer',
      '.footer'
    ];
    var seen = [];
    var items = [];
    var lowerLimit = window.innerHeight + 180;
    var itemLimit = window.innerWidth < 740 ? 10 : 16;

    document.querySelectorAll(selectors.join(',')).forEach(function (element) {
      if (!element || seen.indexOf(element) !== -1 || isTransitionExcluded(element)) {
        return;
      }

      var rect = element.getBoundingClientRect();
      var style = window.getComputedStyle(element);

      if (style.display === 'none' || style.visibility === 'hidden' || rect.width < 2 || rect.height < 2 || rect.bottom < -160 || rect.top > lowerLimit) {
        return;
      }

      seen.push(element);
      items.push({
        element: element,
        distance: Math.hypot(rect.left + rect.width / 2 - origin.x, rect.top + rect.height / 2 - origin.y)
      });
    });

    return items.sort(function (first, second) {
      return first.distance - second.distance;
    }).slice(0, itemLimit);
  }

  function markStyleTransitionItems(origin) {
    collectStyleTransitionItems(origin).forEach(function (item, index) {
      var delay = Math.min(220, Math.round(index * 22 + item.distance / 90));
      item.element.setAttribute('data-chicchok-style-transition-item', '');
      item.element.style.setProperty('--chicchok-style-transition-delay', delay + 'ms');
    });
  }

  function runStyleTransition(safeMode, resolvedStyle, originElement) {
    var origin = getStyleTransitionOrigin(originElement);
    var radius = getStyleTransitionRadius(origin);
    var veil = document.createElement('div');

    clearStyleTransition();

    document.documentElement.setAttribute('data-chicchok-style-transition-last', resolvedStyle);
    document.documentElement.setAttribute('data-chicchok-style-transition-time', String(Date.now()));

    veil.className = 'chicchok-style-transition-veil chicchok-style-transition-veil--' + resolvedStyle;
    veil.style.setProperty('--chicchok-style-transition-x', origin.x + 'px');
    veil.style.setProperty('--chicchok-style-transition-y', origin.y + 'px');
    veil.style.setProperty('--chicchok-style-transition-radius', radius + 'px');
    veil.style.setProperty('--chicchok-style-transition-scale', Math.max(8, radius / 80).toFixed(2));

    document.body.appendChild(veil);
    document.documentElement.classList.add('chicchok-style-transitioning', 'chicchok-style-transitioning--' + resolvedStyle);
    setStyleSwitchersDisabled(true);

    window.requestAnimationFrame(function () {
      commitStyle(safeMode, resolvedStyle);
      markStyleTransitionItems(origin);
    });

    styleTransitionTimer = window.setTimeout(clearStyleTransition, 900);
  }

  function syncSwitchers(mode) {
    var currentLabels = document.querySelectorAll('[data-chicchok-style-current]');
    var options = document.querySelectorAll('[data-chicchok-style-option]');

    currentLabels.forEach(function (label) {
      var switcher = label.closest('[data-chicchok-style-switcher]');
      if (!switcher) return;
      label.textContent = switcher.getAttribute('data-chicchok-style-' + mode + '-label') || switcher.getAttribute('data-chicchok-style-auto-label') || label.textContent;
    });

    options.forEach(function (option) {
      option.setAttribute('aria-pressed', option.getAttribute('data-chicchok-style-option') === mode ? 'true' : 'false');
    });
  }

  function closeSwitcher(switcher) {
    var trigger = switcher.querySelector('[data-chicchok-style-trigger]');
    var menu = switcher.querySelector('[data-chicchok-style-menu]');

    if (!trigger || !menu) {
      return;
    }

    trigger.setAttribute('aria-expanded', 'false');
    menu.hidden = true;
  }

  function closeAllSwitchers(exceptSwitcher) {
    document.querySelectorAll('[data-chicchok-style-switcher]').forEach(function (switcher) {
      if (switcher !== exceptSwitcher) {
        closeSwitcher(switcher);
      }
    });
  }

  function toggleSwitcher(switcher) {
    var trigger = switcher.querySelector('[data-chicchok-style-trigger]');
    var menu = switcher.querySelector('[data-chicchok-style-menu]');

    if (!trigger || !menu) {
      return;
    }

    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    closeAllSwitchers(switcher);
    trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    menu.hidden = expanded;
  }

  function bindSwitchers() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-chicchok-style-trigger]');
      var option = event.target.closest && event.target.closest('[data-chicchok-style-option]');

      if (trigger) {
        event.preventDefault();
        toggleSwitcher(trigger.closest('[data-chicchok-style-switcher]'));
        return;
      }

      if (option) {
        event.preventDefault();
        var switcher = option.closest('[data-chicchok-style-switcher]');
        var originElement = switcher ? switcher.querySelector('[data-chicchok-style-trigger]') : option;
        var mode = option.getAttribute('data-chicchok-style-option') || 'auto';
        var previousStyle = document.documentElement.getAttribute('data-chicchok-style');
        storeMode(mode);
        applyStyle(currentMode, {
          animate: true,
          fromStyle: previousStyle,
          originElement: originElement || option
        });
        closeAllSwitchers();
        return;
      }

      if (!event.target.closest || !event.target.closest('[data-chicchok-style-switcher]')) {
        closeAllSwitchers();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllSwitchers();
      }
    });
  }

  function getRevealItems() {
    var revealSelectors = [
      '.shopify-section--collection-banner .page-header',
      '.shopify-section--main-page .page-header',
      '.shopify-section--main-search .page-header',
      '.shopify-section--main-blog .page-header',
      '.shopify-section--main-cart .page-header',
      '.shopify-section--main-product .product',
      '.product-content',
      '.product-recommendations',
      '.cart-recommendations',
      '.product-facet__aside',
      '.product-facet__meta-bar',
      '.product-item',
      '.line-item',
      '.cart__recap',
      '.main-search__form',
      '.faq__item',
      '.contact__main',
      '.contact__text-item',
      '.article-list > *',
      '.article__info',
      '.article__content',
      '.link-bar',
      '.collection-list .collection-item',
      '.empty-state'
    ];

    return Array.prototype.slice.call(document.querySelectorAll(revealSelectors.join(',')));
  }

  function prepareReveal() {
    var items = getRevealItems();

    items.forEach(function (item, index) {
      if (!item.classList.contains('chicchok-page-reveal')) {
        item.classList.add('chicchok-page-reveal');
        item.style.setProperty('--chicchok-reveal-index', Math.min(index % 8, 7));
      }
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }

    items.forEach(function (item) {
      if (!item.classList.contains('is-visible')) {
        revealObserver.observe(item);
      }
    });
  }

  function markScrolledHeader() {
    document.body.classList.toggle('chicchok-has-scrolled', window.scrollY > 18);
  }

  function preparePageTransitions() {
    if (reduceMotion) {
      return;
    }

    document.addEventListener('click', function (event) {
      if (document.documentElement.getAttribute('data-chicchok-style') !== 'light') {
        return;
      }

      var link = event.target.closest && event.target.closest('a[href]');

      if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
        return;
      }

      if (link.target && link.target !== '_self') {
        return;
      }

      if (link.hasAttribute('download') || link.hasAttribute('data-no-instant') || link.hasAttribute('data-smooth-scroll')) {
        return;
      }

      var url;

      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin || url.protocol === 'mailto:' || url.protocol === 'tel:') {
        return;
      }

      if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) {
        return;
      }

      var href = link.getAttribute('href') || '';

      if (href.indexOf('#') === 0 || href.indexOf('/cart/add') === 0 || link.closest('form')) {
        return;
      }

      event.preventDefault();
      document.body.classList.add('chicchok-route-fading');
      window.setTimeout(function () {
        window.location.href = url.href;
      }, 140);
    });

    window.addEventListener('pageshow', function () {
      document.body.classList.remove('chicchok-route-fading');
    });
  }

  function isLightMobileFacetPage() {
    if (!document.body || document.documentElement.getAttribute('data-chicchok-style') !== 'light') {
      return false;
    }

    if (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-search')) {
      return false;
    }

    return !window.matchMedia || window.matchMedia('(max-width: 999px)').matches;
  }

  function hoistFacetOverlay(controlId) {
    if (!isLightMobileFacetPage()) {
      return;
    }

    var overlay = document.getElementById(controlId);

    if (!overlay || overlay.parentElement === document.body) {
      return;
    }

    if (!overlay.__chicchokFacetPlaceholder && overlay.parentNode) {
      overlay.__chicchokFacetPlaceholder = document.createComment('chicchok-facet-overlay-' + controlId);
      overlay.parentNode.insertBefore(overlay.__chicchokFacetPlaceholder, overlay);
    }

    overlay.setAttribute('data-chicchok-mobile-overlay', '');
    document.body.appendChild(overlay);
  }

  function bindCollectionFacetOverlayFix() {
    if (collectionOverlayFixReady) {
      return;
    }

    collectionOverlayFixReady = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('.mobile-toolbar__item[aria-controls]');

      if (!button) {
        return;
      }

      var controlId = button.getAttribute('aria-controls');

      if (controlId === 'facet-filters' || controlId === 'sort-by-popover') {
        hoistFacetOverlay(controlId);
      }
    }, true);

    document.addEventListener('facet:criteria-changed', function (event) {
      if (!isLightMobileFacetPage() || event.__chicchokForwardedFacetEvent) {
        return;
      }

      var overlay = event.target.closest && event.target.closest('#facet-filters[data-chicchok-mobile-overlay], #sort-by-popover[data-chicchok-mobile-overlay]');

      if (!overlay || overlay.closest('product-facet')) {
        return;
      }

      var productFacet = document.querySelector('product-facet');

      if (!productFacet) {
        return;
      }

      event.stopPropagation();

      var forwardedEvent = new CustomEvent('facet:criteria-changed', {
        bubbles: true,
        detail: event.detail || {}
      });

      forwardedEvent.__chicchokForwardedFacetEvent = true;
      productFacet.dispatchEvent(forwardedEvent);
    }, true);
  }

  function initLightEnhancements() {
    if (!document.body) {
      return;
    }

    document.body.classList.add('chicchok-site-ready');
    prepareReveal();
    markScrolledHeader();
    bindCollectionFacetOverlayFix();

    if (!lightEnhancementsReady) {
      lightEnhancementsReady = true;
      preparePageTransitions();
      window.addEventListener('scroll', markScrolledHeader, { passive: true });
      document.addEventListener('shopify:section:load', function () {
        if (document.documentElement.getAttribute('data-chicchok-style') === 'light') {
          prepareReveal();
          markScrolledHeader();
        }
      });
    }
  }

  function getFlashmailFrameDocument(root) {
    if (!root || root.tagName !== 'IFRAME') {
      return null;
    }

    try {
      return root.contentDocument || (root.contentWindow && root.contentWindow.document) || null;
    } catch (error) {
      return null;
    }
  }

  function injectFlashmailFrameStyles(frameDocument) {
    if (!frameDocument || !frameDocument.head || frameDocument.getElementById('chicchok-flashmail-frame-style-override')) {
      return;
    }

    var style = frameDocument.createElement('style');
    style.id = 'chicchok-flashmail-frame-style-override';
    style.textContent = [
      'html.chicchok-flashmail-open,',
      'html.chicchok-flashmail-open body {',
      'width: 100vw !important;',
      'height: 100vh !important;',
      'min-height: 100vh !important;',
      'margin: 0 !important;',
      'overflow: hidden !important;',
      'background: transparent !important;',
      '}',
      'html.chicchok-flashmail-open #flashmail-popup {',
      'box-sizing: border-box !important;',
      'position: fixed !important;',
      'inset: 0 !important;',
      'display: flex !important;',
      'align-items: center !important;',
      'justify-content: center !important;',
      'visibility: visible !important;',
      'opacity: 1 !important;',
      'width: 100vw !important;',
      'height: 100vh !important;',
      'min-height: 100vh !important;',
      'padding: clamp(18px, 4vw, 56px) !important;',
      'overflow: hidden !important;',
      'pointer-events: auto !important;',
      'background: transparent !important;',
      'box-shadow: none !important;',
      '}',
      'html.chicchok-flashmail-open body > div {',
      'box-sizing: border-box !important;',
      'position: fixed !important;',
      'inset: 0 !important;',
      'display: flex !important;',
      'align-items: center !important;',
      'justify-content: center !important;',
      'width: 100vw !important;',
      'height: 100vh !important;',
      'padding: clamp(18px, 4vw, 56px) !important;',
      'background: transparent !important;',
      'box-shadow: none !important;',
      'pointer-events: none !important;',
      '}',
      'html.chicchok-flashmail-open #flashmail-popup::before,',
      'html.chicchok-flashmail-open #flashmail-popup::after,',
      'html.chicchok-flashmail-open body::before,',
      'html.chicchok-flashmail-open body::after,',
      'html.chicchok-flashmail-open body > div::before,',
      'html.chicchok-flashmail-open body > div::after {',
      'display: none !important;',
      'visibility: hidden !important;',
      'opacity: 0 !important;',
      'content: none !important;',
      'background: transparent !important;',
      '}',
      'html.chicchok-flashmail-open .chicchok-flashmail-sticky-tab {',
      'display: none !important;',
      'visibility: hidden !important;',
      'opacity: 0 !important;',
      'pointer-events: none !important;',
      '}',
      'html.chicchok-flashmail-open .popup-block.node-type-popup,',
      'html.chicchok-flashmail-open .popup-block.node-type-page {',
      'box-sizing: border-box !important;',
      'position: relative !important;',
      'top: auto !important;',
      'right: auto !important;',
      'bottom: auto !important;',
      'left: auto !important;',
      'margin: auto !important;',
      'transform: none !important;',
      'float: none !important;',
      'flex: 0 1 auto !important;',
      'width: min(94vw, 520px) !important;',
      'max-width: min(94vw, 520px) !important;',
      'max-height: min(88vh, 720px) !important;',
      'overflow: auto !important;',
      'pointer-events: auto !important;',
      'background: transparent !important;',
      'box-shadow: none !important;',
      '}',
      'html.chicchok-flashmail-open .popup-block.node-type-popup::before,',
      'html.chicchok-flashmail-open .popup-block.node-type-popup::after,',
      'html.chicchok-flashmail-open .popup-block.node-type-page::before,',
      'html.chicchok-flashmail-open .popup-block.node-type-page::after {',
      'display: none !important;',
      'visibility: hidden !important;',
      'opacity: 0 !important;',
      'content: none !important;',
      'background: transparent !important;',
      '}',
      'html[data-chicchok-style="light"] form.zalify-popup-panel {',
      '--chicchok-zalify-surface: #fcfaf5;',
      '--chicchok-zalify-surface-soft: #f8f3ea;',
      '--chicchok-zalify-ink: #231f1e;',
      '--chicchok-zalify-muted: #6c625a;',
      '--chicchok-zalify-wine: #911b26;',
      '--chicchok-zalify-line: #c7b8a4;',
      'color: var(--chicchok-zalify-ink) !important;',
      'background-color: var(--chicchok-zalify-surface) !important;',
      'background-image: none !important;',
      'border-color: var(--chicchok-zalify-line) !important;',
      'box-shadow: 0 24px 70px rgba(35, 31, 30, .18) !important;',
      'color-scheme: light;',
      '}',
      'html[data-chicchok-style="light"] form.zalify-popup-panel .popup-block {',
      'color: inherit !important;',
      '}',
      'html[data-chicchok-style="light"] form.zalify-popup-panel .popup-block:not(.node-type-popup):not(.node-type-page):not(.node-type-sticky_tab):not(.node-type-button) {',
      'background-color: transparent !important;',
      'background-image: none !important;',
      '}',
      'html[data-chicchok-style="light"] form.zalify-popup-panel .popup-block.node-type-sticky_tab {',
      'background-color: var(--chicchok-zalify-surface) !important;',
      'color: var(--chicchok-zalify-wine) !important;',
      'border: 1px solid var(--chicchok-zalify-line) !important;',
      'box-shadow: 0 10px 28px rgba(35, 31, 30, .14) !important;',
      '}',
      'html[data-chicchok-style="light"] form.zalify-popup-panel .popup-block.node-type-popup,',
      'html[data-chicchok-style="light"] form.zalify-popup-panel .popup-block.node-type-page {',
      'background-color: var(--chicchok-zalify-surface) !important;',
      'background-image: none !important;',
      'color: var(--chicchok-zalify-ink) !important;',
      'border-color: var(--chicchok-zalify-line) !important;',
      'box-shadow: 0 24px 70px rgba(35, 31, 30, .18) !important;',
      '}',
      'html[data-chicchok-style="light"] form.zalify-popup-panel .popup-block.node-type-section,',
      'html[data-chicchok-style="light"] form.zalify-popup-panel .popup-block.node-type-column {',
      'background-color: transparent !important;',
      'color: inherit !important;',
      'border-color: var(--chicchok-zalify-line) !important;',
      '}',
      'html[data-chicchok-style="light"] form.zalify-popup-panel h1,',
      'html[data-chicchok-style="light"] form.zalify-popup-panel h2,',
      'html[data-chicchok-style="light"] form.zalify-popup-panel h3 {',
      'color: var(--chicchok-zalify-wine) !important;',
      '}',
      'html[data-chicchok-style="light"] form.zalify-popup-panel p,',
      'html[data-chicchok-style="light"] form.zalify-popup-panel label {',
      'color: var(--chicchok-zalify-muted) !important;',
      '}',
      'html[data-chicchok-style="light"] form.zalify-popup-panel input {',
      'background-color: #fff !important;',
      'color: var(--chicchok-zalify-ink) !important;',
      'border-color: var(--chicchok-zalify-line) !important;',
      '}',
      'html[data-chicchok-style="light"] form.zalify-popup-panel button[type="submit"],',
      'html[data-chicchok-style="light"] form.zalify-popup-panel .popup-block.node-type-button {',
      'background-color: var(--chicchok-zalify-wine) !important;',
      'background-image: none !important;',
      'color: #fff !important;',
      'border-color: var(--chicchok-zalify-wine) !important;',
      '}',
      'html[data-chicchok-style="light"] form.zalify-popup-panel button[aria-label*="close" i],',
      'html[data-chicchok-style="light"] form.zalify-popup-panel [class*="close"][role="button"] {',
      'color: var(--chicchok-zalify-wine) !important;',
      'background-color: var(--chicchok-zalify-surface-soft) !important;',
      'background-image: none !important;',
      'border: 1px solid var(--chicchok-zalify-line) !important;',
      '}'
    ].join('');

    frameDocument.head.appendChild(style);
  }

  function syncFlashmailFrameMode(root) {
    var frameDocument = getFlashmailFrameDocument(root);

    if (!frameDocument || !frameDocument.documentElement) {
      return;
    }

    var resolvedStyle = isLightStyle() ? 'light' : 'dark';
    if (frameDocument.documentElement.getAttribute('data-chicchok-style') !== resolvedStyle) {
      frameDocument.documentElement.setAttribute('data-chicchok-style', resolvedStyle);
    }

    if (frameDocument.body && frameDocument.body.getAttribute('data-chicchok-style') !== resolvedStyle) {
      frameDocument.body.setAttribute('data-chicchok-style', resolvedStyle);
    }

    injectFlashmailFrameStyles(frameDocument);
  }

  function resetFlashmailFrame(root, preserveObserver) {
    root = root || document.getElementById('popup-shadow-root');

    if (root) {
      root.classList.remove('chicchok-flashmail-sticky-host', 'chicchok-flashmail-open-host');
    }

    var frameDocument = getFlashmailFrameDocument(root);

    if (frameDocument && frameDocument.documentElement) {
      frameDocument.documentElement.classList.remove('chicchok-flashmail-open');

      if (frameDocument.body) {
        frameDocument.body.classList.remove('chicchok-flashmail-open');
      }

      frameDocument.querySelectorAll('.chicchok-flashmail-sticky-tab').forEach(function (stickyTab) {
        stickyTab.classList.remove('chicchok-flashmail-sticky-tab');
      });
    }

    var popup = document.getElementById('flashmail-popup');
    var sticky = document.querySelector('#flashmail-popup .chicchok-flashmail-sticky-tab, .chicchok-flashmail-sticky-tab');

    if (popup) {
      popup.classList.remove('chicchok-flashmail-sticky-host');
    }

    if (sticky) {
      sticky.classList.remove('chicchok-flashmail-sticky-tab');
    }

    if (!preserveObserver && flashmailFrameObserver) {
      clearFlashmailFrameBinding();
    }
  }

  function syncFlashmailFrame(root) {
    syncFlashmailFrameMode(root);

    if (!isLightStyle()) {
      resetFlashmailFrame(root, true);
      syncFlashmailFrameMode(root);
      return;
    }

    var frameDocument = getFlashmailFrameDocument(root);

    if (!root || !frameDocument || !frameDocument.documentElement) {
      return;
    }

    var popup = frameDocument.getElementById('flashmail-popup');
    var sticky = frameDocument.querySelector('#flashmail-popup .popup-block.node-type-sticky_tab, #flashmail-popup [class*="popup-block"][class*="node-type-sticky_tab"], .popup-block.node-type-sticky_tab, [class*="popup-block"][class*="node-type-sticky_tab"]');
    var openBlocks = frameDocument.querySelectorAll('#flashmail-popup .popup-block.node-type-popup, #flashmail-popup .popup-block.node-type-page, .popup-block.node-type-popup, .popup-block.node-type-page');
    var isOpen = false;

    if (frameDocument.defaultView) {
      Array.prototype.some.call(openBlocks, function (openBlock) {
        var openBlockStyle = frameDocument.defaultView.getComputedStyle(openBlock);
        var openBlockRect = openBlock.getBoundingClientRect();
        isOpen = openBlockStyle.display !== 'none' && openBlockStyle.visibility !== 'hidden' && openBlockStyle.opacity !== '0' && openBlockRect.width > 0 && openBlockRect.height > 0;
        return isOpen;
      });
    }

    injectFlashmailFrameStyles(frameDocument);

    if (sticky) {
      sticky.classList.add('chicchok-flashmail-sticky-tab');
    }

    if (popup || sticky || openBlocks.length) {
      root.classList.add('chicchok-flashmail-sticky-host');
    }

    root.classList.toggle('chicchok-flashmail-open-host', isOpen);
    frameDocument.documentElement.classList.toggle('chicchok-flashmail-open', isOpen);

    if (frameDocument.body) {
      frameDocument.body.classList.toggle('chicchok-flashmail-open', isOpen);
    }
  }

  function bindFlashmailFrameObserver(root) {
    if (!root || root.tagName !== 'IFRAME') {
      return;
    }

    if (!flashmailLoadBound.has(root)) {
      flashmailLoadBound.add(root);
      root.addEventListener('load', function () {
        scheduleFlashmailSync();
      });
    }

    var frameDocument = getFlashmailFrameDocument(root);

    if (!root || !frameDocument || !frameDocument.documentElement || !('MutationObserver' in window)) {
      return;
    }

    if (flashmailFrameDocument === frameDocument && flashmailFrameObserver) {
      return;
    }

    clearFlashmailFrameBinding();
    flashmailFrameDocument = frameDocument;
    flashmailFrameObserver = new MutationObserver(function (mutations) {
      if (document.hidden) {
        return;
      }

      var relevant = mutations.some(function (mutation) {
        if (mutation.type === 'childList') {
          return true;
        }

        if (mutation.attributeName === 'class' && stripFlashmailClasses(mutation.oldValue) === stripFlashmailClasses(mutation.target.getAttribute('class'))) {
          return false;
        }

        var popup = frameDocument.getElementById('flashmail-popup');
        return mutation.target === frameDocument.documentElement || mutation.target === frameDocument.body || !!mutation.target.closest(flashmailBlockSelector) || !!(popup && mutation.target.contains(popup));
      });

      if (relevant) {
        scheduleFlashmailSync();
      }
    });
    flashmailFrameObserver.observe(frameDocument.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-expanded']
    });
    flashmailEventsDocument = frameDocument;
    ['click', 'keydown', 'transitionend', 'animationend', 'load'].forEach(function (eventName) {
      frameDocument.addEventListener(eventName, scheduleFlashmailSync, true);
    });
    stopFlashmailPolling();
  }

  function stripFlashmailClasses(value) {
    return (value || '').split(/\s+/).filter(function (className) {
      return className && className.indexOf('chicchok-flashmail-') !== 0;
    }).join(' ');
  }

  function clearFlashmailFrameBinding() {
    if (flashmailFrameObserver) {
      flashmailFrameObserver.disconnect();
      flashmailFrameObserver = null;
    }

    if (flashmailEventsDocument) {
      ['click', 'keydown', 'transitionend', 'animationend', 'load'].forEach(function (eventName) {
        flashmailEventsDocument.removeEventListener(eventName, scheduleFlashmailSync, true);
      });
      flashmailEventsDocument = null;
    }

    flashmailFrameDocument = null;
  }

  function scheduleFlashmailSync() {
    if (flashmailSyncFrame !== null || document.hidden) {
      return;
    }

    flashmailSyncFrame = window.requestAnimationFrame(function () {
      flashmailSyncFrame = null;
      markFlashmailStickyHost();
    });
  }

  function stopFlashmailPolling() {
    if (flashmailPollTimer !== null) {
      window.clearTimeout(flashmailPollTimer);
      flashmailPollTimer = null;
    }
  }

  function startFlashmailPolling() {
    if (flashmailPollTimer !== null || document.hidden || flashmailPollAttempts >= 20 || flashmailFrameObserver) {
      return;
    }

    flashmailPollTimer = window.setTimeout(function () {
      flashmailPollTimer = null;
      flashmailPollAttempts += 1;
      markFlashmailStickyHost();
      startFlashmailPolling();
    }, 500);
  }

  function markFlashmailStickyHost() {
    if (document.hidden) {
      return;
    }

    var root = document.getElementById('popup-shadow-root');

    if (!root && flashmailFrameDocument) {
      clearFlashmailFrameBinding();
      flashmailPollAttempts = 0;
      startFlashmailPolling();
    }

    syncFlashmailFrameMode(root);

    if (!isLightStyle()) {
      resetFlashmailFrame(root, true);
      syncFlashmailFrameMode(root);
      bindFlashmailFrameObserver(root);
      return;
    }

    if (root) {
      root.classList.add('chicchok-flashmail-sticky-host');
      syncFlashmailFrame(root);
      bindFlashmailFrameObserver(root);
    }

    var popup = document.getElementById('flashmail-popup');
    var sticky = document.querySelector('#flashmail-popup .popup-block.node-type-sticky_tab, #flashmail-popup [class*="popup-block"][class*="node-type-sticky_tab"]');

    if (popup) {
      popup.classList.add('chicchok-flashmail-sticky-host');
    }

    if (!sticky) {
      return;
    }

    sticky.classList.add('chicchok-flashmail-sticky-tab');
    root = sticky.closest('#popup-shadow-root');

    if (!root && popup) {
      root = popup.closest('#popup-shadow-root');
    }

    if (!root) {
      root = document.getElementById('popup-shadow-root');
    }

    if (root) {
      root.classList.add('chicchok-flashmail-sticky-host');
    }
  }

  function injectFlashmailOverrides() {
    if (document.getElementById('chicchok-flashmail-style-override') || !document.head) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'chicchok-flashmail-style-override';
    style.textContent = [
      'html[data-chicchok-style="light"] #flashmail-popup,',
      'html[data-chicchok-style="light"] #flashmail-popup .popup-block.node-type-sticky_tab,',
      'html[data-chicchok-style="light"] #flashmail-popup [class*="popup-block"][class*="node-type-sticky_tab"],',
      'html[data-chicchok-style="light"] #flashmail-popup.chicchok-flashmail-sticky-host,',
      'html[data-chicchok-style="light"] .chicchok-flashmail-sticky-tab {',
      'display: block !important;',
      'visibility: visible !important;',
      'opacity: 1 !important;',
      'pointer-events: auto !important;',
      '}',
      'html[data-chicchok-style="light"] #popup-shadow-root.chicchok-flashmail-sticky-host {',
      'display: block !important;',
      'visibility: visible !important;',
      'opacity: 1 !important;',
      'position: fixed !important;',
      'top: 50% !important;',
      'right: 0 !important;',
      'bottom: auto !important;',
      'left: auto !important;',
      'width: 48px !important;',
      'height: 132px !important;',
      'max-width: 48px !important;',
      'max-height: 132px !important;',
      'transform: translateY(-50%) !important;',
      'z-index: 180 !important;',
      'pointer-events: auto !important;',
      'overflow: visible !important;',
      'border: 0 !important;',
      '}',
      'html[data-chicchok-style="light"] #popup-shadow-root.chicchok-flashmail-open-host,',
      'html[data-chicchok-style="light"] #popup-shadow-root.chicchok-flashmail-sticky-host.chicchok-flashmail-open-host {',
      'display: block !important;',
      'visibility: visible !important;',
      'opacity: 1 !important;',
      'position: fixed !important;',
      'top: 0 !important;',
      'right: 0 !important;',
      'bottom: 0 !important;',
      'left: 0 !important;',
      'width: 100vw !important;',
      'height: 100vh !important;',
      'max-width: none !important;',
      'max-height: none !important;',
      'transform: none !important;',
      'z-index: 2147483000 !important;',
      'pointer-events: auto !important;',
      'overflow: visible !important;',
      'border: 0 !important;',
      'background: transparent !important;',
      '}',
      'html[data-chicchok-style="light"].lock-all .chicchok-flashmail-sticky-tab,',
      'html[data-chicchok-style="light"].lock-mobile .chicchok-flashmail-sticky-tab {',
      'visibility: hidden !important;',
      'opacity: 0 !important;',
      'pointer-events: none !important;',
      '}',
      'html[data-chicchok-style="light"].lock-all #popup-shadow-root.chicchok-flashmail-sticky-host:not(.chicchok-flashmail-open-host),',
      'html[data-chicchok-style="light"].lock-mobile #popup-shadow-root.chicchok-flashmail-sticky-host:not(.chicchok-flashmail-open-host) {',
      'position: fixed !important;',
      'top: 50% !important;',
      'right: 0 !important;',
      'bottom: auto !important;',
      'left: auto !important;',
      'width: 48px !important;',
      'height: 132px !important;',
      'max-width: 48px !important;',
      'max-height: 132px !important;',
      'transform: translateY(-50%) !important;',
      'z-index: 180 !important;',
      'overflow: visible !important;',
      'pointer-events: none !important;',
      '}',
      'html[data-chicchok-style="light"].lock-all #popup-shadow-root.chicchok-flashmail-open-host #popup-container,',
      'html[data-chicchok-style="light"].lock-mobile #popup-shadow-root.chicchok-flashmail-open-host #popup-container,',
      'html[data-chicchok-style="light"].lock-all #popup-shadow-root.chicchok-flashmail-open-host #flashmail-popup,',
      'html[data-chicchok-style="light"].lock-mobile #popup-shadow-root.chicchok-flashmail-open-host #flashmail-popup {',
      'display: block !important;',
      'visibility: visible !important;',
      'opacity: 1 !important;',
      'pointer-events: auto !important;',
      '}',
      'html[data-chicchok-style="light"].lock-all #popup-shadow-root.chicchok-flashmail-sticky-host #flashmail-popup .chicchok-flashmail-sticky-tab,',
      'html[data-chicchok-style="light"].lock-mobile #popup-shadow-root.chicchok-flashmail-sticky-host #flashmail-popup .chicchok-flashmail-sticky-tab {',
      'display: none !important;',
      'visibility: hidden !important;',
      'opacity: 0 !important;',
      'pointer-events: none !important;',
      '}'
    ].join('');

    document.head.appendChild(style);
  }

  function injectHomeLegacyLightStyles() {
    var legacyStyle = document.getElementById('chicchok-home-legacy-light-style');
    if (legacyStyle) {
      legacyStyle.remove();
    }
    return;

    if (document.getElementById('chicchok-home-legacy-light-style') || !document.head) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'chicchok-home-legacy-light-style';
    style.textContent = [
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"],',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__testimonials"],',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"],',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__video_aD3nx4"],',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__text-with-icons"],',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"],',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__newsletter"]{background:var(--chicchok-ivory)!important;color:var(--chicchok-ink)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .section,',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__testimonials"] .section__color-wrapper,',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .section__color-wrapper,',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__text-with-icons"] .section__color-wrapper{background:#f8f6f4!important;color:var(--chicchok-ink)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"]{--heading-color:21,21,21;--text-color:108,98,90;--primary-button-background:122,14,19;--primary-button-text-color:255,255,255;--section-accent-background:252 250 245 / 1;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text{padding:clamp(46px,6vw,84px) 0!important;background:linear-gradient(180deg,var(--chicchok-ivory),var(--chicchok-warm-white))!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text__wrapper{gap:clamp(36px,6vw,76px);align-items:center;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text__image-wrapper{border:1px solid var(--chicchok-line);border-radius:6px;overflow:hidden;background:#fff;box-shadow:0 24px 70px rgba(21,21,21,.10);}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text__image{filter:brightness(1.06) contrast(.93) saturate(.88);}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text__content{color:var(--chicchok-muted)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text__content .heading--small{color:var(--chicchok-wine)!important;letter-spacing:.08em!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text__content .h3{color:var(--chicchok-ink)!important;font-weight:400!important;line-height:1.08!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text__text-wrapper,',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text__text-wrapper p{color:var(--chicchok-muted)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text__navigation{border-color:var(--chicchok-line)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text__navigation-item{color:var(--chicchok-muted)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text__navigation-item[aria-current="true"]{color:var(--chicchok-wine)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__testimonials"]{--heading-color:21,21,21;--text-color:108,98,90;--section-background:248,246,244;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__testimonials"] .section__color-wrapper{padding:clamp(42px,6vw,78px) 0!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__testimonials"] .testimonial-list{background:transparent!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__testimonials"] .testimonial{background:transparent!important;color:var(--chicchok-ink)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__testimonials"] .blockquote{color:var(--chicchok-ink)!important;font-weight:300!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__testimonials"] .blockquote::before{color:rgba(122,14,19,.10)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__testimonials"] .testimonial__author{color:var(--chicchok-muted)!important;letter-spacing:.08em!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"]{--heading-color:21,21,21;--text-color:108,98,90;--prev-next-button-background:248,246,244;--prev-next-button-color:122,14,19;--section-background:248,246,244;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .section__color-wrapper{padding:clamp(36px,6vw,78px) 0!important;background:#f8f6f4!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .section__header .h2{color:var(--chicchok-ink)!important;font-weight:300!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .timeline__item{--heading-color:21,21,21;--text-color:108,98,90;--section-box-background:248,246,244;background:transparent!important;color:var(--chicchok-muted)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .timeline__image-wrapper{border:1px solid var(--chicchok-line);border-radius:6px;overflow:hidden;background:#fff;box-shadow:0 24px 70px rgba(21,21,21,.10);}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .timeline__image{filter:brightness(1.1) contrast(.88) saturate(.82);opacity:.92;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .timeline__content,',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .timeline__content p{color:var(--chicchok-muted)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .timeline__nav-wrapper{border-color:var(--chicchok-line)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .timeline__nav-item{color:var(--chicchok-muted)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .timeline__nav-item[aria-current="true"]{color:var(--chicchok-wine)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .progress-bar{background:rgba(185,154,91,.38)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__video_aD3nx4"]{--heading-color:21,21,21;--text-color:108,98,90;--primary-button-background:122,14,19;--primary-button-text-color:255,255,255;background:var(--chicchok-ivory)!important;padding:0 0 clamp(42px,6vw,82px)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__video_aD3nx4"] .video-section{max-width:min(1180px,calc(100vw - 48px));margin:0 auto;border:1px solid var(--chicchok-line);border-radius:6px;overflow:hidden;background:#fff;box-shadow:0 24px 70px rgba(21,21,21,.10);}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__video_aD3nx4"] video{filter:brightness(1.05) contrast(.92) saturate(.86);}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__text-with-icons"]{--heading-color:21,21,21;--text-color:108,98,90;--section-background:248,246,244;background:#f8f6f4!important;border-top:1px solid var(--chicchok-line);border-bottom:1px solid var(--chicchok-line);}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__text-with-icons"] .text-with-icons{background:transparent!important;color:var(--chicchok-muted)!important;padding:clamp(32px,5vw,58px) 0!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__text-with-icons"] .text-with-icons__item-title{color:var(--chicchok-ink)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__text-with-icons"] svg{color:var(--chicchok-wine)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"]{background:#f8f6f4!important;color:var(--chicchok-ink)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] *{border-color:var(--chicchok-line)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class^="ai-testimonial-slider-"]{background:#f8f6f4!important;color:var(--chicchok-ink)!important;padding:clamp(48px,7vw,86px) 20px!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__heading-"],',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__heading-"] p{color:var(--chicchok-ink)!important;font-weight:300!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__subheading-"],',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__subheading-"] p{color:var(--chicchok-muted)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__container-"]{max-width:760px!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__image-wrapper-"]{background:#fff!important;border:1px solid var(--chicchok-line)!important;box-shadow:0 20px 55px rgba(21,21,21,.10)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__image-wrapper-"] img{filter:brightness(1.06) contrast(.92) saturate(.9)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__star-"]{fill:var(--chicchok-gold)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__text-"],',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__text-"] p,',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__text-"] strong{color:var(--chicchok-muted)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__text-"] strong{color:var(--chicchok-wine)!important;font-weight:500!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__arrow-"]{background:#fff!important;color:var(--chicchok-wine)!important;border:1px solid var(--chicchok-line)!important;box-shadow:0 16px 36px rgba(21,21,21,.10)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__arrow-"]:hover{background:var(--chicchok-wine)!important;color:#fff!important;border-color:var(--chicchok-wine)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__dot-"]{background:var(--chicchok-line)!important;border:0!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__blocks_MATFXE"] [class*="ai-testimonial-slider__dot-"].active{background:var(--chicchok-wine)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__newsletter"]{--heading-color:21,21,21;--text-color:108,98,90;--section-block-background:252,250,245;--primary-button-background:122,14,19;--primary-button-text-color:255,255,255;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__newsletter"] .image-with-text-block{background:var(--chicchok-ivory)!important;}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__newsletter"] .image-with-text-block__image{filter:brightness(1.08) contrast(.9) saturate(.86);}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__newsletter"] .image-with-text-block__content{background:rgba(252,250,245,.94)!important;color:var(--chicchok-muted)!important;border:1px solid var(--chicchok-line);box-shadow:0 24px 70px rgba(21,21,21,.10);}',
      'html[data-chicchok-style="light"] body.template-index #main > [id$="__newsletter"] .heading{color:var(--chicchok-ink)!important;}',
      '@media screen and (max-width:740px){html[data-chicchok-style="light"] body.template-index #main > [id$="__image-with-text"] .image-with-text{padding:34px 0!important;}html[data-chicchok-style="light"] body.template-index #main > [id$="__timeline"] .section__color-wrapper{padding:34px 0!important;}html[data-chicchok-style="light"] body.template-index #main > [id$="__video_aD3nx4"] .video-section{max-width:calc(100vw - 24px);}}'
    ].join('');

    document.head.appendChild(style);
  }

  function bindFlashmailObserver() {
    injectFlashmailOverrides();
    markFlashmailStickyHost();

    if (flashmailObserver || !('MutationObserver' in window)) {
      startFlashmailPolling();
      return;
    }

    flashmailObserver = new MutationObserver(function (mutations) {
      if (document.hidden) {
        return;
      }

      var relevant = mutations.some(function (mutation) {
        if (mutation.target.nodeType === 1 && mutation.target.closest(flashmailSelector)) {
          return true;
        }

        return Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes)).some(function (node) {
          return node.nodeType === 1 && (node.matches(flashmailSelector) || node.querySelector(flashmailSelector));
        });
      });

      if (relevant) {
        scheduleFlashmailSync();
      }
    });

    flashmailObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    startFlashmailPolling();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopFlashmailPolling();

        if (flashmailSyncFrame !== null) {
          window.cancelAnimationFrame(flashmailSyncFrame);
          flashmailSyncFrame = null;
        }
        return;
      }

      scheduleFlashmailSync();
      startFlashmailPolling();
    });

    window.addEventListener('resize', scheduleFlashmailSync, { passive: true });
  }

  function nudgeZalifyPopupLoad() {
    if (zalifyPopupNudgeReady) {
      return;
    }

    zalifyPopupNudgeReady = true;

    window.setTimeout(function () {
      if (document.getElementById('flashmail-popup') || document.getElementById('popup-shadow-root')) {
        return;
      }

      if (!document.querySelector('.zalify-popup[data-app-key], .zalify-layout[data-app-key]') || zalifyPopupStartAttempted) {
        return;
      }

      zalifyPopupStartAttempted = true;

      try {
        if (window.zalify && typeof window.zalify.start === 'function') {
          window.zalify.start();
        }
      } catch (error) {}
    }, 2400);
  }

  function init() {
    currentMode = readMode();
    bindSwitchers();
    injectHomeLegacyLightStyles();
    bindFlashmailObserver();
    bindCartmaxObserver();
    applyStyle(currentMode);
    nudgeZalifyPopupLoad();

    window.setInterval(function () {
      if (currentMode === 'auto') {
        applyStyle(currentMode);
      }
    }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
